import { EmailVerification } from './EmailVerification';

document.addEventListener('DOMContentLoaded', function () {
  window.Webflow ||= [];

  window.Webflow.push(async () => {
    const app = new EmailVerification();
    app.init();
    document.documentElement.classList.add('webflow-loaded');
  });
});
